import React from 'react'
import { Flex, Heading, IconButton, Stack } from '@chakra-ui/react'
import { ChevronRightIcon } from '@chakra-ui/icons'

export const SectionHeader = ( props ) => {
  let type = props?.icontype
  const { setShowMore, title, iconOne, iconTwo } = props
  return (
    <Flex
      className="section__header"
      justify="space-between"
      align="center"
      marginTop={2}
    >
      <Heading
        fontSize="2xl"
        fontFamily="regular"
        fontWeight="medium"
        my={2}
        {...props}
      >
        {title}
      </Heading>
      {type === "iconBtn" && iconTwo !== null
        ? <Stack isInline id="iconBtns" justifyContent="flex-end">
          <IconButton
            icon={iconOne}
            borderRadius="full"
            size="sm"
          // _hover={{ bg: 'brand.brighterRed', outline: "none" }}
          >
          </IconButton>
          <IconButton
            icon={iconTwo}
            borderRadius="full"
            size="sm"
          // _hover={{ bg: 'brand.brighterRed', outline: "none" }}
          >
          </IconButton>
        </Stack>
        : iconTwo === null && type === "iconBtn"
          ? <IconButton
            icon={iconOne}
            type="button"
            borderRadius="full"
            size="sm"
            verticalAlign="middle"
            fill="currentColor"
            // _hover={{ bg: 'brand.brighterRed', outline: "none" }}
            onClick={() => setShowMore( showMore => !showMore )}>
          </IconButton>
          : type === "icon"
            ? <ChevronRightIcon
              fill="currentColor"
              w="1.8em"
              h="1.8em"
            />
            : null}
    </Flex>
  )
}